import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  authToken: null,
  id: null,
  name: "",
  email: "",
  user_type: 0,
  error: null,
};

const authStart = (state) => {
  return updateObject(state, { error: null, loading: true });
};

const authSuccess = (state, action) => {
  return updateObject(state, {
    authToken: action.authToken,
    error: null,
    loading: false,
    name: action.name,
    email: action.email,
    id: action.id,
    user_type: action.user_type,
  });
};

const authFail = (state, action) => {
  if (action.error?.data) {
    const data = action.error.data;
    const subtitle = data.subtitle || data.message || "We could not complete your request, please try again.";
    const title = data.title || (data.message ? "" : "Error");
    return updateObject(state, {
      error: { title, subtitle },
      loading: false,
    });
  }
  return updateObject(state, {
    error: {
      title: "",
      subtitle: "We could not complete your request, please try again.",
    },
    loading: false,
  });
};

const authLogout = (state) => {
  return updateObject(state, {
    authToken: null,
    fname: null,
    user_id: null,
    loading: false,
  });
};

const updateAccount = (state, action) => {
  return updateObject(state, {
    name: action.name,
    email: action.email,
  });
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state);
    case actionTypes.UPDATE_ACCOUNT_SUCCESS:
      return updateAccount(state, action);

    default:
      return state;
  }
};

export default reducer;
